<template>
  <div>
    <EfetivarIncricaoDialog 
      v-model="efetivarIncricaoDialogOpened"
      :edicaoEvento="edicaoEvento"
      :autenticacao="autenticacao"
      :autenticado="autenticado"
      @onSave="() => refresh()"/>

    <v-progress-linear
        v-if="loading"
        :active="loading"
        indeterminate
        color="primary"
        height="4"
      ></v-progress-linear>
    <v-card v-if="collEdicoesAtivas.length === 0" class="elevation-0">
      <v-card-text class="text-center">
        <p>{{ descEdicaoNaoEncontrada }}</p>
      </v-card-text>
    </v-card>
    <v-row>
      <v-col cols="12" md="4" v-for="item of collEdicoesAtivas" :key="item.id" class="ultima-coluna">
        <v-card>
          <img
              :src="item.urlImgCapa"
              class="img-capa"
              alt="Capa do Evento"
            />
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{ item.descricao }}</h3>
            </div>
          </v-card-title>
          <v-divider/>
          <v-card-text class="py-4 flex-grow-1">
            <v-row dense class="pa-4">
              <!-- Período de inscrição -->
              <v-col cols="12" class="mb-2 mt-4">
                <v-icon color="primary" class="mr-2">mdi-calendar-check</v-icon>
                <span class="titulo-detalhe font-weight-bold">Período de inscrição: </span>
                <span class="detalhe">
                  {{ item.dtInicioInscricao | moment("DD/MM/YYYY") }} a
                  {{ item.dtFimInscricao | moment("DD/MM/YYYY") }}
                </span>
              </v-col>
              <!-- Local -->
              <v-col :cols="(item.inscrito === 1 ? 6 : 12)" class="mb-2 mt-4">
                <v-icon color="primary" class="mr-2">mdi-map-marker</v-icon>
                <span class="titulo-detalhe font-weight-bold">Local: </span>
                <span class="detalhe">{{ item.cidade }}/{{ item.estado }}</span>
              </v-col>
              <!-- Publico Alvo -->
              <v-col :cols="(item.inscrito === 1 ? 6 : 12)" class="mb-2 mt-4">
                <v-icon color="primary" class="mr-2">mdi-account-group</v-icon>
                <span class="titulo-detalhe font-weight-bold">Público Alvo: </span>
                <span class="detalhe">{{ descPublicoAlvo(item.publicoAlvo) }}</span>
              </v-col>
              <!-- tipo  -->
              <v-col :cols="(item.inscrito === 1 ? 6 : 12)" class="mb-2 mt-4">
                <v-icon color="primary" class="mr-2">mdi-ticket-confirmation-outline</v-icon>
                <span class="titulo-detalhe font-weight-bold">Inscrição: </span>
                <span class="detalhe">{{ item.descTipoAcessoEvento }}</span>
              </v-col>

              <v-col cols="12" class="mb-2 mt-4" v-if="item.inscrito === 1">
                <v-icon color="green" class="mr-2">mdi-check-circle</v-icon>
                <span class="detalhe font-weight-bold">Inscrição realizada</span>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary" 
              :disabled="loading"
              @click="detalheEdicaoEvento(item)">
              <v-icon left>mdi-magnify</v-icon>
              Detalhes do Evento
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <!-- <v-col cols="12" class align="right">
        <div class="text-xs-center">
          <v-pagination
            v-model="pageOptions.page"
            :length="pageOptions.totalPages"
            :total-visible="4"
            circle
            :disabled="loading || totalElements <= 0 || pageOptions.totalPages <= 1"
            @input="onPageChange"
          ></v-pagination>
        </div>
      </v-col> -->
    </v-row>
  </div>
</template>

<script>
import {findAllEventoEdicaoAtivasPublica} from "../../../api/eventoEdicao";
import {findInscricaoPorToken} from "../../../api/eventoInscricao";
import {ApiError} from "../../../api/core";
import EfetivarIncricaoDialog from "./EfetivarIncricaoDialog";
import {mapGetters} from "vuex";

export default {
  name: "InscrevaSe2Form",
  components: {EfetivarIncricaoDialog},
  props: {
    autenticacao: {
      type: Object,
      default: () => ({
        dadosLogado: {
          token: "",
          current: {}
        },
        encontrou: 0
      })
    },
    idEmpresa: {
      type: [Number, String],
      default: null
    },
    nivel: {
      type: [String, Number],
      default: null
    },
    descNivel: {
      type: String,
      default: ""
    },
    autenticado: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      edicaoEvento: {},
      efetivarIncricaoDialogOpened: false,
      error: null,
      pageOptions: {
        page: 1,
        totalPages: 1
      },
      itemsPerPage: 0,
      totalElements: 0,
      collEdicoesAtivas: [],
      searchValues: {},
      refreshRequestId: 0,
    }
  },
  watch: {
    // Watcher único para evitar múltiplas chamadas duplicadas
    propsTrigger: {
      handler(newVal) {
        if (
          newVal.idEmpresa &&
          newVal.nivel &&
          newVal.autenticado
        ) {
          this.updateSearchValues();
        } else {
          // Se algum dado faltar, limpa busca
          this.searchValues = {};
          this.pageOptions.page = 1;
          this.refresh();
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated','nivelUsuarioLogado']),
    descEdicaoNaoEncontrada() {
      if (this.autenticado && this.descNivel) {
        return `Nenhuma Edição de Evento ativa foi encontrada para ${this.descNivel}.`;
      } else {
        return "Nenhuma Edição de Evento ativa foi encontrada.";
      }
    },
    propsTrigger() {
      // Junta os props relevantes para o watcher único
      return {
        idEmpresa: this.idEmpresa,
        nivel: this.nivel,
        autenticado: this.autenticado
      };
    }
  },
  methods: {
    updateSearchValues() {
      if (this.autenticado && this.idEmpresa && this.nivel) {
        this.searchValues = {
          idEmpresa: this.idEmpresa,
          nivel: this.nivel
        };
      } else {
        this.searchValues = {};
      }
      this.pageOptions.page = 1;
      this.refresh();
    },
    onPageChange(page) {
      this.refresh();
    },
    descPublicoAlvo(publicoAlvo) {
      if (publicoAlvo === "FOR") return "Somente Fornecedores";
      if (publicoAlvo === "COM") return "Somente Compradores";
      if (publicoAlvo === "TOD") return "Compradores e Fornecedores";
      return "";
    },
    async refresh() {
      const requestId = ++this.refreshRequestId;

      try {
        this.error = null;
        this.loading = true;
        const page = await findAllEventoEdicaoAtivasPublica(this.pageOptions.page, 0, this.searchValues);

        if (requestId !== this.refreshRequestId) return;

        this.itemsPerPage = page.elementsPerPage;
        this.totalElements = page.totalElements;
        this.pageOptions.page = page.currentPage;
        this.pageOptions.totalPages = page.totalPages;
        const collEdicoes = await Promise.all(
          page.elements.map(async el => {
            const retornoInscricao = await this.verificarInscricao(el.id);
            return { ...el, ...retornoInscricao };
          })
        );

        if (requestId !== this.refreshRequestId) return;

        this.collEdicoesAtivas = collEdicoes;
      } catch (err) {
        if (requestId !== this.refreshRequestId) return;

        this.error = err;
        this.collEdicoesAtivas = [];        
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {
          this.$toast.error(`Não foi possível carregar a lista de Edicões de Eventos Ativas. ${err.message}`, {
            timeout: 6000
          })
        }   
      } finally {
        if (requestId === this.refreshRequestId) {
          this.loading = false;
        }
      }
    },
    async verificarInscricao(id) {
      let retorno = {
          inscrito: 0,
          idInscricao: null,
          dtInscricao: "",
          descStatus: "",
          maisDetalheInscricao: "",
          cronogramaInscricao: [],
          ofertaDemanda: [],
      }
      if (!this.autenticado) return retorno;
      try {
        let dadosInscricao = await findInscricaoPorToken(id);
        if (dadosInscricao?.current){
          retorno.inscrito = 1;
          retorno.idInscricao = dadosInscricao?.current.id || null;          
          retorno.dtInscricao = dadosInscricao?.current.dtInscricao;
          retorno.descStatus = dadosInscricao?.current.descStatus;
          retorno.maisDetalheInscricao = dadosInscricao?.current.maisDetalhe;
          retorno.cronogramaInscricao = dadosInscricao?.current.cronograma || [];
          retorno.ofertaDemanda = dadosInscricao?.current.ofertaDemanda || [];
        }
        console.log("retorno verificarInscricao", retorno);
        return retorno;
      } catch (err) {
        return retorno;
      }
    },
    detalheEdicaoEvento(objeto) {
      try {
        this.loading = true;
        this.edicaoEvento = objeto;
        this.efetivarIncricaoDialogOpened = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados da Edição deste Evento. Tente Novamente mais tarde.`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    },     
  },
  mounted() {
    this.pageOptions.page = 1;
  }
}
</script>

<style scoped lang="scss">
.ultima-coluna {
  margin-bottom: 10px;
}
.titulo-detalhe {
  font-size: 1rem; // Tamanho médio para título de seção
  font-weight: 600;
  color: #37474F; // Cinza escuro
}

.detalhe {
  font-size: 0.95rem;
  color: #555; // Cinza mais suave
  line-height: 1.4;
}

.titulo-insc-realizada {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2E7D32; // Verde escuro para indicar sucesso
  display: flex;
  align-items: center;

  v-icon {
    margin-right: 6px;
  }
}

.borda-footer {
  border-top: 1px solid #E0E0E0;
  padding-top: 16px;
  margin-top: 16px;
}

.card-accent-section {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
}
.img-capa {
  width: 100%;
  height: 200px; /* Define uma altura fixa para todas as imagens */
  display: block;
  object-fit: cover; /* Mantém a proporção sem distorcer, cortando se necessário */
  object-position: center; /* Centraliza a imagem na área delimitada */
  // border-radius: 8px; /* opcional: deixa a imagem com cantos arredondados */
}
</style>